import type { SimplePromise } from 'bv-typings'
import type { IPolicyInsightType } from '@/pages/PolicyInsight'
import { batchEditEntityPolicy, editEntityPolicyLarr, getEntityPolicyDetail, getEntityPolicyList } from './entity'
import {
  batchEditBlacklist,
  getBlacklistDetail,
  getBlacklistList,
  singleEditBlacklist,
} from '@/services/policyInsight/blacklist'
import { getList } from '@/services/policyInsight/entitySpend'


type IServiceMap =  Record<IPolicyInsightType, SimplePromise>


const listService: IServiceMap = {
  entity: getEntityPolicyList,
  blacklist: getBlacklistList,
  // @ts-ignore
  spend: getList,
}

const detailService: IServiceMap = {
  entity: getEntityPolicyDetail,
  blacklist: getBlacklistDetail,
}

const batchService: IServiceMap = {
  entity: batchEditEntityPolicy,
  blacklist: batchEditBlacklist,
}
const editService: IServiceMap = {
  entity: editEntityPolicyLarr,
  blacklist: singleEditBlacklist,
}

export {
  listService,
  detailService,
  batchService,
  editService,
}
